export enum EstadoConsumo {
    Pendiente = 0,
    Desconocido = 1,
    Reconocido = 2
}
